export function textLengthInWords(text: string): number {
  return text.split(" ").length;
}

export function textLengthInMinutes(textLength: number): number {
    return Math.round(textLength/140) || 1;
}